jQuery(document).ready(function () {
    $(document).on('click', '.dnCopyToClipboard', function (e) {
        var clipboard = $(this);
        var clipboardInput = clipboard.children('.dnCopyToClipboard-input');
        clipboardInput.select();

        document.execCommand('copy');

        if (window.getSelection) {
            window.getSelection().removeAllRanges();
        } else if (document.selection) {
            document.selection.empty();
        }
    });
});